export default __webpack_public_path__ + "static/media/bano-mobile.07506f43.jpg";